module.exports = __webpack_public_path__ + "static/media/flag management attendance.e475775a.svg";